import React, { useState, useRef, useEffect } from 'react'
import { UserAvatar } from './UserAvatar'
import { ChevronDown, Settings, LogOut } from 'lucide-react'
import { useNavigate } from 'react-router-dom'
import '../modern-theme.css'

export function UserWelcomeBanner({
  userName,
  welcomeMessage = 'Welcome Back 👋',
  avatarSrc,
  isOnline = true,
  className = '',
}) {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false)
  const dropdownRef = useRef(null)
  const navigate = useNavigate()

  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false)
      }
    }
    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [])

  const handleLogout = () => {
    localStorage.removeItem('token')
    localStorage.removeItem('role')
    localStorage.removeItem('first_name')
    localStorage.removeItem('last_name')
    localStorage.removeItem('userid')
    navigate('/')
  }

  return (
    <div
      className={`welcome-banner ${className}`}
      style={{
        margin: 0,
        marginTop: 8,
        marginBottom: 8,
        borderRadius: 16,
        boxShadow: '0 2px 8px 0 rgba(0,0,0,0.04)',
        padding: '20px 32px',
        background: '#fff',
        width: '100%',
      }}
    >
      <div className="d-flex justify-content-between align-items-center">
        <div className="welcome-content">
          <div
            className="welcome-message"
            style={{
              color: '#888',
              fontSize: 15,
              fontWeight: 500,
              marginBottom: 2,
            }}
          >
            {welcomeMessage}
          </div>
          <h2
            className="user-name"
            style={{ fontSize: 28, fontWeight: 700, margin: 0 }}
          >
            {userName}
          </h2>
        </div>
        <div
          className="d-flex align-items-center position-relative"
          ref={dropdownRef}
        >
          <div
            className="d-flex align-items-center cursor-pointer"
            onClick={() => setIsDropdownOpen(!isDropdownOpen)}
            style={{ cursor: 'pointer' }}
          >
            <UserAvatar
              src={avatarSrc}
              isOnline={isOnline}
              alt={`${userName}'s avatar`}
            />
            <div className="ms-2">
              <ChevronDown
                size={16}
                className="text-gray-500"
                style={{
                  transform: isDropdownOpen ? 'rotate(180deg)' : 'rotate(0deg)',
                  transition: 'transform 0.2s ease',
                }}
              />
            </div>
          </div>

          {/* Dropdown Menu */}
          {isDropdownOpen && (
            <div
              style={{
                position: 'absolute',
                top: '100%',
                right: 0,
                marginTop: '8px',
                background: '#fff',
                borderRadius: '12px',
                boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
                padding: '8px 0',
                minWidth: '200px',
                zIndex: 1000,
              }}
            >
              <button
                onClick={() => {
                  navigate('/settings')
                  setIsDropdownOpen(false)
                }}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  width: '100%',
                  padding: '12px 16px',
                  border: 'none',
                  background: 'transparent',
                  color: '#333',
                  fontSize: '14px',
                  cursor: 'pointer',
                  gap: '8px',
                }}
                onMouseOver={(e) =>
                  (e.currentTarget.style.background = '#f5f5f5')
                }
                onMouseOut={(e) =>
                  (e.currentTarget.style.background = 'transparent')
                }
              >
                <Settings size={16} />
                Profile Settings
              </button>
              <button
                onClick={handleLogout}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  width: '100%',
                  padding: '12px 16px',
                  border: 'none',
                  background: 'transparent',
                  color: '#DE3C7D',
                  fontSize: '14px',
                  cursor: 'pointer',
                  gap: '8px',
                }}
                onMouseOver={(e) =>
                  (e.currentTarget.style.background = '#f5f5f5')
                }
                onMouseOut={(e) =>
                  (e.currentTarget.style.background = 'transparent')
                }
              >
                <LogOut size={16} />
                Logout
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}
